import type { ComponentType, JSX, PropsWithChildren } from 'react';

import { TrackingContext } from '@change-corgi/core/react/tracking';

import type { ErrorStateDetails } from 'src/app/shared/utils/async';
import { isError, isLoaded } from 'src/app/shared/utils/async';

import type { PetitionGuidesPageCombinedState, PetitionGuidesPagePrefetchedContext } from './hook';
import { usePageContext } from './hook';
import { PetitionGuidesPageDataContextProvider } from './pageData';

export type ErrorHandlerProps = { context: ErrorStateDetails<PetitionGuidesPageCombinedState> };

type Props = {
	prefetchedData: PetitionGuidesPagePrefetchedContext | undefined;
	errorHandler: ComponentType<ErrorHandlerProps>;
	loadingFallback: JSX.Element;
};

export function PetitionGuidesPageContextProvider({
	children,
	prefetchedData,
	errorHandler: ErrorHandler,
	loadingFallback,
}: PropsWithChildren<Props>): JSX.Element | null {
	const pageContextState = usePageContext(prefetchedData);

	if (isError(pageContextState)) {
		const { status, ...rest } = pageContextState;
		return <ErrorHandler context={rest} />;
	}
	if (!isLoaded(pageContextState)) return loadingFallback;

	const { pageData } = pageContextState;

	return (
		<PetitionGuidesPageDataContextProvider pageData={pageData}>
			<TrackingContext properties={{}}>{children}</TrackingContext>
		</PetitionGuidesPageDataContextProvider>
	);
}
